// extracted by mini-css-extract-plugin
export var creativeTitle = "NextPrevProject-module--creativeTitle--82a31";
export var gatsbyImgWrapper = "NextPrevProject-module--gatsbyImgWrapper--219d2";
export var media = "NextPrevProject-module--media--9fce4";
export var previousStyle = "NextPrevProject-module--previousStyle--cc1de";
export var projectContainer = "NextPrevProject-module--projectContainer--95be1";
export var text = "NextPrevProject-module--text--18c3f";